import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { PLAN_CONTRIBUTION_SETTINGS_FRAGMENT } from "~/shared/fragments/PlanContributionSettingFragment"
import type { Query, QueryBenefitsTemplateOfferForArgs } from "@oysterhr/schema"

const BENEFITS_TEMPLATE_OFFER_FOR_QUERY = gql`
  ${PLAN_CONTRIBUTION_SETTINGS_FRAGMENT}
  query BenefitsTemplateOfferFor($countryCode: String!, $currencyCode: String!) {
    benefitsTemplateOfferFor(countryCode: $countryCode) {
      tiers {
        collection {
          id
          name
          fee {
            currencyCode
            subunit
            subunitToUnit
            formatted
          }
          includedPlans {
            id
            name
            fee {
              currencyCode
              subunit
              subunitToUnit
              formatted
            }
            descriptiveName
            provider {
              id
              name
            }
            costSplitAllowed
            category
            coverageTypes
            guideUrl
            priceEstimate(currencyCode: $currencyCode, engagementType: "employment") {
              id
              currencies {
                currencyCode
                subunit
                subunitToUnit
                formatted
              }
              isDefault
            }
            ...PlanContributionSettingFragment
            dependentsConfig
          }
        }
      }
      addons {
        collection {
          id
          name
          fee {
            currencyCode
            subunit
            subunitToUnit
            formatted
          }
          descriptiveName
          provider {
            id
            name
          }
          costSplitAllowed
          category
          coverageTypes
          guideUrl
          priceEstimate(currencyCode: $currencyCode, engagementType: "employment") {
            id
            currencies {
              currencyCode
              subunit
              subunitToUnit
              formatted
            }
            isDefault
          }
          dependentsConfig
          ...PlanContributionSettingFragment
        }
      }
    }
  }
`

export const useBenefitsTemplateOfferFor = ({
  countryCode,
  currencyCode,
}: Pick<QueryBenefitsTemplateOfferForArgs, "countryCode"> & { currencyCode: string }) => {
  return useQuery<Pick<Query, "benefitsTemplateOfferFor">>(BENEFITS_TEMPLATE_OFFER_FOR_QUERY, {
    variables: { countryCode, currencyCode },
  })
}
